"use client";
import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/PlaidImportModal/AddAccountRow";

import { Icon } from "@ospweb/sdk-ui";
import React from "react";

const I18n = I18nUtil.createScoped(Translations);

export interface AddAccountRowProps {
  onClick: () => void;
}

/**
 * Dashed-border row that opens the Add Account flow.
 * AC-2.4: Clicking triggers onAddAccount.
 */
export const AddAccountRow: React.FC<AddAccountRowProps> = ({ onClick }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex w-full flex-col items-center justify-center rounded-3 border border-dashed border-border_inverse_transparent20 p-3"
      data-testid="add-account-row"
    >
      <div className="flex items-center justify-center gap-2.5">
        <div className="flex size-6 items-center justify-center rounded-3 bg-background_brand_overlay20">
          <Icon name="plus" size={20} className="text-content_brand_primary" />
        </div>
        <p className="body_medium_s text-content_brand_primary">
          {I18n.t("Add a new account")}
        </p>
      </div>
    </button>
  );
};
